import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import { getActivationCode } from '../api'

const styles = theme => ({
  gray: {
    backgroundColor: theme.borderColor,
    padding: 70,
    margin: 20,
    boxShadow: 'none'
  },
  code: {
    padding: 30,
    textAlign: 'center'
  }
})

class CodeModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      code: '',
      canClose: false
    }
  }

  componentWillReceiveProps (newProps) {
    if (newProps.open && !this.state.code) { this.getNewActivationCode() }
  }

  getNewActivationCode = () => {
    getActivationCode().then(response => {
      this.setState({ code: response, canClose: true })
    })
  }

  onClose = () => this.setState({code: '', canClose: false}, this.props.onClose)

  render () {
    const { classes } = this.props

    if (!this.props.open) return null;
    return (
      <Dialog open={this.props.open} onClose={this.onClose}>
        <DialogTitle>Success!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This is your new activation code. Provide it to your patient so they can activate their device.
          </DialogContentText>
          <Paper className={classes.gray}>
            <Paper className={classes.code}>{this.state.code}</Paper>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={this.onClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles)(CodeModal)



// WEBPACK FOOTER //
// ./src/components/CodeModal.js